"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function ImpactedresourcesMulticolorOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M6.049 6.015l.363.799a4.896 4.896 0 01-.363-.799zM10.586 3.22v1.904a.291.291 0 01-.168-.243V2.504c.112.222.17.467.168.715zM10.558 5.636a.06.06 0 01.028 0v.798h-.028a.298.298 0 01-.068-.056.481.481 0 01-.06-.067.743.743 0 01-.04-.08.75.75 0 01-.028-.088.704.704 0 010-.092.644.644 0 010-.088.564.564 0 01.068-.168.482.482 0 01.06-.068.318.318 0 01.068-.091z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCE5FF",
    d: "M8.285 12.298a3.183 3.183 0 100-6.367 3.183 3.183 0 000 6.367z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M10.418 2.504v2.377a.292.292 0 00.168.243V3.22a1.57 1.57 0 00-.168-.715zm.14 3.132a.317.317 0 00-.068.06.482.482 0 00-.06.067.497.497 0 00-.068.168.644.644 0 000 .088.704.704 0 000 .092.75.75 0 00.028.088.744.744 0 00.04.08.482.482 0 00.06.067c.02.022.042.041.068.056h.028v-.798a.06.06 0 00-.028.032zm-1.17 3.546v5.22a.4.4 0 01-.4.4h-6.39a.4.4 0 01-.4-.4V3.22a.4.4 0 01.4-.4h3.395c.133-.421.32-.824.559-1.197H2.598A1.598 1.598 0 001 3.219v11.183A1.598 1.598 0 002.598 16h6.39a1.598 1.598 0 001.598-1.598V9.374a4.76 4.76 0 01-1.199-.192z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M5.84 5.216H4.196a.4.4 0 110-.799h1.57v.4c.017.134.042.268.076.4zM6.412 6.814H4.195a.4.4 0 110-.799H6.05l.363.799zM7.674 8.296a.4.4 0 01-.283.115H4.195a.4.4 0 110-.798h2.772c.126.14.26.273.4.4.083.099.2.19.307.283zM5.793 10.808a1.198 1.198 0 100 2.396 1.198 1.198 0 000-2.396zm0 1.598a.4.4 0 110-.8.4.4 0 010 .8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.813.587A3.71 3.71 0 008.25 1.61a3.69 3.69 0 00-.847 1.198 3.707 3.707 0 00-.323 1.518v.08a3.3 3.3 0 00.032.399c.015.135.04.268.076.4.064.277.164.545.295.798.085.17.184.33.296.483a3.682 3.682 0 002.796 1.558h.227a3.738 3.738 0 003.739-3.738A3.738 3.738 0 0010.813.587zm0 6.878h-.227a3.115 3.115 0 01-2.26-1.226 3.16 3.16 0 01-.58-1.258v-.024l-.056-.42v-.211c.002-.532.14-1.054.4-1.518A3.195 3.195 0 019.231 1.61a3.127 3.127 0 011.597-.44 3.144 3.144 0 013.127 3.168 3.143 3.143 0 01-3.143 3.139v-.012zm.26-1.841l-.08-.04-.088-.028a.455.455 0 00-.18 0l-.088.028-.051.028a.06.06 0 00-.028 0 .322.322 0 00-.068.06.495.495 0 00-.06.067.575.575 0 00-.068.168.678.678 0 000 .088.74.74 0 000 .092.75.75 0 00.028.088.743.743 0 00.04.08.494.494 0 00.128.123h.028l.051.028a.323.323 0 00.088.028h.18a.376.376 0 00.088-.028.314.314 0 00.08-.043.443.443 0 00.072-.056.472.472 0 000-.651l-.072-.032zm-.487-.512c.07.039.15.058.231.056.216 0 .4-.136.4-.3V2.473c0-.163-.18-.3-.4-.3-.22 0-.4.137-.4.3V4.87a.291.291 0 00.169.255v-.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M10.813 0a4.337 4.337 0 00-3.379 1.622 4.49 4.49 0 00-.679 1.198c-.183.485-.276.999-.275 1.517v.08c0 .136 0 .268.028.4s.036.267.06.4c.059.272.141.54.247.798.058.137.124.27.196.4a4.317 4.317 0 002.376 1.997c.386.136.79.217 1.199.239h.227a4.341 4.341 0 004.342-4.314A4.341 4.341 0 0010.813 0zm0 7.477h-.227a3.115 3.115 0 01-2.263-1.23 3.16 3.16 0 01-.577-1.266v-.024a2.863 2.863 0 01-.056-.42v-.211c.002-.532.14-1.054.4-1.518A3.195 3.195 0 019.231 1.61a3.127 3.127 0 011.597-.44 3.143 3.143 0 013.127 3.167 3.143 3.143 0 01-3.143 3.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M11.213 2.492V4.89c0 .163-.18.3-.4.3a.471.471 0 01-.231-.057.291.291 0 01-.168-.243V2.492c0-.163.18-.3.4-.3.219 0 .399.137.399.3zM11.277 6.019c0 .122-.047.24-.132.327a.443.443 0 01-.072.056.31.31 0 01-.08.044.374.374 0 01-.088.028h-.18a.324.324 0 01-.087-.028l-.052-.028h-.028a.298.298 0 01-.068-.056.482.482 0 01-.06-.067.744.744 0 01-.04-.08.75.75 0 01-.028-.088.704.704 0 010-.092.644.644 0 010-.088.564.564 0 01.068-.168.482.482 0 01.06-.068.32.32 0 01.068-.06.06.06 0 01.028 0l.052-.027.088-.028a.455.455 0 01.18 0l.087.028.08.04.072.06c.078.079.125.184.132.295z"
  }));
}

ImpactedresourcesMulticolorOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
ImpactedresourcesMulticolorOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = ImpactedresourcesMulticolorOutline;
exports["default"] = _default;